const moment = require("moment");
export default {
  methods: {
    getLog(item) {
      const {
        rateTypeCode,
        itemBuy,
        itemSell,
        adultBuy,
        adultSell,
        childBuy,
        childSell,
        infantBuy,
        infantSell,
        currencyBuy,
        currencySell,
        currencyBuyExchangeRate,
        currencySellExchangeRate,
      } = item.pricing;
      const supplierCommission = item.supplierCommission;
      return {
        date: moment().format("YYYY-MM-DD"),
        time: moment().format("HH:mm"),
        username: this.$store.getters.userConfig.username,
        rateType: rateTypeCode,
        itemBuy,
        itemSell,
        adultBuy,
        adultSell,
        childBuy,
        childSell,
        infantBuy,
        infantSell,
        currencyBuy,
        currencySell,
        currencyBuyExchangeRate,
        currencySellExchangeRate,
        supplierCommission,
      };
    },
    addLog(item) {
      item.pricing.logs.push(this.getLog(item));
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/gt/itineraries/builder/mixins/pricing-log.js